export const scrollToFrame = () => {
    const element = document.getElementsByClassName('frame-wrapper-div');
    const paddingTop = 60;
    const finalOffset = element[0].offsetTop - paddingTop;
    window.scrollTo({
        top: finalOffset / 2,
        behavior: 'auto',
    });
};
